/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Chiropractic_TermsInputs */

const en_service_type_chiropractic_terms = /** @type {(inputs: Service_Type_Chiropractic_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`chiropractor, spinal adjustment`)
};

const pl_service_type_chiropractic_terms = /** @type {(inputs: Service_Type_Chiropractic_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`chiropraktyk, kręgarz, nastawianie kręgosłupa`)
};

/**
* | output |
* | --- |
* | "chiropractor, spinal adjustment" |
*
* @param {Service_Type_Chiropractic_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_chiropractic_terms = /** @type {((inputs?: Service_Type_Chiropractic_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Chiropractic_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_chiropractic_terms(inputs)
	return en_service_type_chiropractic_terms(inputs)
});